import { cn } from "@/common/utils/cn";
import { forwardRef, ReactNode, Ref } from "react";

interface PrintContextProps {
  content: ReactNode;
  backgroundColor: string;
  color: string;
  className?: string;
}

const PrintContext = forwardRef(({ content, backgroundColor, color, className }: PrintContextProps, ref) => {
  return (
    <div
      ref={ref as Ref<HTMLDivElement>}
      className={cn(
        'hidden print:flex print:justify-center w-full font-mono',
        className,
      )}
      style={{
        whiteSpace: 'pre-wrap',
        wordWrap: 'break-word',
        overflowWrap: 'break-word',
        backgroundColor,
        color,
      }}
    >
      <div style={{ maxWidth: '100%', minWidth: 0, backgroundColor: 'white' }}>
        {content}
      </div>
    </div>
  )
})

export default PrintContext;
